import { on, off } from 'delegated-events'
import { useState, useEffect } from 'react'
import References from './References'
import Testimonials from './Testimonials'
import ShowColumnButton from './ShowColumnButton'

let windowWidth = window.innerWidth

const initialReferences = document.getElementById('initial-references').textContent
const initialTestimonials = document.getElementById('initial-testimonials')?.textContent

const referencesData = JSON.parse(initialReferences)
const testimonialsData = initialTestimonials ? JSON.parse(initialTestimonials) : false

const supportsTwoColumns = testimonialsData !== false

const isInitialMobileSize = window.matchMedia('(max-width: 767px)').matches

function App() {
  const [isMobileSize, setIsMobileSize] = useState(isInitialMobileSize)
  const [referencesVisible, setReferencesVisible] = useState(true)
  const [testimonialsVisible, setTestimonialsVisible] = useState(supportsTwoColumns && !isInitialMobileSize)

  const containerClasses = referencesVisible && testimonialsVisible ? 'grid grid-cols-2 gap-16' : ''
  const canHide = referencesVisible && testimonialsVisible && !isMobileSize

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth != windowWidth) {
        windowWidth = window.innerWidth

        setIsMobileSize(window.matchMedia('(max-width: 767px)').matches)
      }
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [setIsMobileSize])

  useEffect(() => {
    const listenerArgs = [
      'pagefilters:update',
      'html',
      (e) => {
        // We need to dynamically set this placeholder value since the default category is set on load
        const majorSelect = document.querySelector('[data-page-filters] #major-category')

        if (majorSelect) {
          if (e.detail.type === 'clear') {
            majorSelect.querySelector('[data-placeholder]').textContent = 'Corporate'
          } else {
            majorSelect.querySelector('[data-placeholder]').textContent = 'Categories'
          }
        }
      },
    ]

    on(...listenerArgs)

    return () => off(...listenerArgs)
  }, [])

  const hideColumn = (column) => {
    if (column === 'references') {
      setReferencesVisible(false)
    }

    if (column === 'testimonials') {
      setTestimonialsVisible(false)
    }
  }

  const showColumn = (column) => {
    if (column === 'references') {
      setReferencesVisible(true)

      if (isMobileSize) {
        setTestimonialsVisible(false)
      }
    }

    if (column === 'testimonials') {
      setTestimonialsVisible(true)

      if (isMobileSize) {
        setReferencesVisible(false)
      }
    }
  }

  return (
    <div>
      {supportsTwoColumns && (
        <div className="mb-8 text-right md:-mt-6">
          {!referencesVisible && <ShowColumnButton column="references" showColumn={showColumn} />}
          {!testimonialsVisible && <ShowColumnButton column="testimonials" showColumn={showColumn} />}
        </div>
      )}
      <div className={`${containerClasses}`}>
        <References
          data={referencesData}
          isVisible={referencesVisible}
          supportsTwoColumns={supportsTwoColumns}
          hideColumn={hideColumn}
          canHide={canHide}
        />
        {testimonialsData && (
          <Testimonials
            data={testimonialsData}
            isVisible={testimonialsVisible}
            supportsTwoColumns={supportsTwoColumns}
            hideColumn={hideColumn}
            canHide={canHide}
          />
        )}
      </div>
    </div>
  )
}

export default App
